import { render, staticRenderFns } from "./versea_city_com.vue?vue&type=template&id=ca379e56&scoped=true"
import script from "./versea_city_com.vue?vue&type=script&lang=js"
export * from "./versea_city_com.vue?vue&type=script&lang=js"
import style0 from "./versea_city_com.vue?vue&type=style&index=0&id=ca379e56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca379e56",
  null
  
)

export default component.exports